import React, { useRef, useState } from "react";
// import myLogo from "../img/my-logo-2.png";
import jayStoreLogo from "../img/jayStoreLogo.png";

export default function SectionFigure(props) {
  const [isActive, setIsActive] = useState(false);
  const popupRef = useRef();
  const openPopup = (e) => {
    e.preventDefault();
    popupRef.current.classList.add("open-popup");
  };

  const closePopup = (e) => {
    e.preventDefault();
    popupRef.current.classList.remove("open-popup");
  };

  const popupLogoHoverIn = () => {
    setIsActive(true);
  };

  const popupLogoHoverOut = () => {
    setIsActive(false);
  };

  return (
    <>
      <figure className={`main-figure ${props.figGridPlacement}`}>
        <div className="main-figure-inner">
          <h3 className="heading-tertiary">{props.heading}</h3>
          <ul>
            <li>{props.listItem1}</li>
            <li>{props.listItem2}</li>
            <li>{props.listItem3}</li>
          </ul>
          <a
            href={props.appURL}
            target={props.appURL === "/" ? "_self" : "_blank"}
            rel="noreferrer"
            className="btn link-btn visit-link"
            onClick={() => {
              if (props.appURL === "/") {
                // eslint-disable-next-line no-restricted-globals
                openPopup(event);
              }
            }}
          >
            VISIT
          </a>
        </div>
      </figure>

      {/* Popup */}
      {/* <div className="nav-popup-backgrd" ref={popupRef}> */}
      <div className="nav-popup" ref={popupRef}>
        <div className="nav-popup-data-div">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              className="popup-LogoImage"
              src={jayStoreLogo}
              alt="Jayant Arora logo"
            />
          </div>
          <span style={{ textAlign: "center" }}>{props.popupBody}</span>
        </div>

        <div className="main-nav-contact">
          <a
            className="contact-btn contact-link popup-close-btn"
            href={props.appURL}
            onMouseEnter={() => popupLogoHoverIn()}
            onMouseLeave={() => popupLogoHoverOut()}
            style={{
              color: !isActive ? "#fff" : props.popupBackColor,
              backgroundColor: !isActive ? props.popupBackColor : "#e5e5e5",
              border: `1px solid ${props.popupBackColor}20`,
            }}
            // eslint-disable-next-line no-restricted-globals
            onClick={() => closePopup(event)}
          >
            I Understand
          </a>
        </div>
      </div>
      {/* </div> */}
    </>
  );
}
